export default __webpack_public_path__ + "static/media/linkedin.6e9a0a5c.svg";